import type { Dispatch } from '/business/shared/state/actions/types';

const setDashboardApplicationsState = (applicationState: string) => async (dispatch: Dispatch) => {
  dispatch({ type: 'SET_DASHBOARD_APPLICATIONS_STATE', applicationState });
};

export default setDashboardApplicationsState;
